import Grid2 from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
import { UseFormWatch } from "react-hook-form";
import { useEffect } from "react";
import { debounce, isEmpty } from "lodash";
import { useNavigate, useParams } from "react-router-dom";

import colors from "../../styles/colors/colors";
import fontWeight from "../../styles/mui/fontWeight";
import {
  alignStart,
  displayFlex,
  flexColumn,
  flexRow,
} from "../../styles/mui/styles/display";
import {
  PatientDetailsContainer,
} from "../../components/styles/styles";
import { decryptId, encryptId, getGender, getLanguageLabel, getSessionStorage, getValue } from "../../utils";
import { MemberInfoData } from "../../models/Patient";
import { ApplicationRoute } from "../../constants/ApplicationUrl";
import { formatDate } from "../../utils/DateTime";
import { DateFormats } from "../../constants/Date";

export interface PropsFromState {
  watch: UseFormWatch<any>;
  memberInfoDataState: MemberInfoData;
  type: number;
}
type AllProps = PropsFromState;

const PatientHeader: React.FC<any> = ({ memberInfoDataState, type }: AllProps) => {

  const navigate = useNavigate();
  const { referralId, providerId } = useParams();
  
  useEffect(() => {
    if (
      !isEmpty(memberInfoDataState) &&
      getValue(memberInfoDataState, "memberName") === ""
    ) {
      const debounceEffect = debounce(()=>{
      const actualReferralId = referralId && !isEmpty(getSessionStorage("samlToken")) ? decryptId(referralId) : referralId;
      const actualProviderId = providerId && !isEmpty(getSessionStorage("samlToken")) ? decryptId(providerId) : providerId;
      const encryReferralId = actualReferralId ? !isEmpty(getSessionStorage("samlToken")) ? encryptId(actualReferralId) : actualReferralId : null;
      const encryProviderId = actualProviderId ? !isEmpty(getSessionStorage("samlToken")) ? encryptId(actualProviderId) : actualProviderId : null;
      if (type == 2) {
        if(referralId && providerId) {
        navigate(
          `${ApplicationRoute.RE_AUTH_MEMBER_INFO}/${(encryReferralId)}/${(encryProviderId)}`,
        );
      }
      } else {
        navigate(ApplicationRoute.MEMBER_INFO);
      }
      },500);
      debounceEffect();
    }
  }, [memberInfoDataState, referralId, providerId]);

  const fieldRenderY = (label: string, value: string | number | null) => {
    return (
      <Grid2>
        <Typography
          variant="body1"
          fontWeight={fontWeight[3]}
          color={colors.fonts[2]}
        >
          {label}
        </Typography>
        <Box sx={displayFlex} pt={1}>
          <Typography
            variant="body2"
            fontWeight={fontWeight[5]}
            color={colors.fonts[4]}
          >
            {value}
          </Typography>
        </Box>
      </Grid2>
    );
  };
  const fieldRenderX = (label: string, value: string | number | null) => {
    return (<Grid2 size={{ xs: 12 }} sx={flexRow}>
            <Typography
              variant="body1"
              fontWeight={fontWeight[3]}
        color={colors.fonts[2]}
        pt={1}
            >
              {label}
            </Typography>
            <Box sx={displayFlex} pl={1} pt={1}>
              <Typography
                variant="body2"
                fontWeight={fontWeight[5]}
                color={colors.fonts[4]}
              >
                {value}
              </Typography>
            </Box>
          </Grid2>)
  }

  return (
    <Grid2 container sx={PatientDetailsContainer}>
      <Grid2 size={{ xs: 1.5 }} pl={"1.5rem"}>
        <Grid2 container sx={flexColumn}>
          <Grid2 size={{ xs: 12 }}>
            <Typography
              variant="h3"
              fontWeight={fontWeight[6]}
              color={colors.fonts[18]}
            >
              {getValue(memberInfoDataState, "memberName")}
            </Typography>
          </Grid2>
          <Grid2 size={{ xs: 12 }} mt={1}>
            {fieldRenderX("DOB : ", formatDate(getValue(memberInfoDataState, "dob"), DateFormats.MM_DD_YYYY))}
          </Grid2>
          <Grid2 size={{ xs: 12 }} mt={1}>
            {fieldRenderX("Gender : ", getGender(getValue(memberInfoDataState, "gender")))}
          </Grid2>
        </Grid2>
      </Grid2>
      <Grid2 size={{ xs: 0.8 }} sx={alignStart}>
        {fieldRenderY(
          "Subscriber Id",
          getValue(memberInfoDataState, "subscriberId")
        )}
      </Grid2>
      <Grid2 size={{ xs: 0.5 }} sx={alignStart}>
        {fieldRenderY("MBI", getValue(memberInfoDataState, "mbi"))}
      </Grid2>
      <Grid2 size={{ xs: 1 }} sx={alignStart}>
        {fieldRenderY(
          "Health Plan",
          getValue(memberInfoDataState, "healthPlan")
        )}
      </Grid2>
      <Grid2 size={{ xs: 1.8 }} sx={alignStart}>
        {fieldRenderY(
          "Residential Address",
          getValue(memberInfoDataState, "residentialAddress")
        )}
      </Grid2>
      <Grid2 size={{ xs: 1.5 }} sx={alignStart}>
        {fieldRenderY(
          "Mailing Address",
          getValue(memberInfoDataState, "mailingAddress")
        )}
      </Grid2>
      <Grid2 size={{ xs: 1 }} sx={alignStart}>
        {fieldRenderY(
          "Phone Number",
          getValue(memberInfoDataState, "phoneNumber")
        )}
      </Grid2>
      <Grid2 size={{ xs: 0.5 }} sx={alignStart}>
        {fieldRenderY("Language", getLanguageLabel(
           getValue(memberInfoDataState, "memberPreferredLanguage")
        ))}
      </Grid2>
    </Grid2>
  );
};

export default PatientHeader;
